import { CloseOutlined } from '@ant-design/icons';
// biome-ignore lint/style/noRestrictedImports: <tbd>
import { Drawer as AntDrawer, type DrawerProps } from 'antd';
import * as React from 'react';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';

export interface IDrawerProps extends DrawerProps {
  title: React.ReactNode;
}

/**
 * Drawer modificato per supportare gli attributi ARIA
 */
export function Drawer(props: IDrawerProps) {
  const { title, ...otherProps } = props;
  const { t } = useTranslation();
  const titleId = useId();

  const closeIconRef = React.useRef<HTMLSpanElement>(null);

  return (
    <AntDrawer
      afterOpenChange={open => {
        if (!open) return;

        const buttonElement = closeIconRef.current?.parentElement;
        if (!buttonElement) return;

        try {
          buttonElement?.setAttribute(
            'aria-label',
            t('drawer.close-aria', 'Chiudi Pannello'),
          );
          buttonElement.focus?.();
          closeIconRef.current?.removeAttribute('aria-label');
        } catch (e) {
          // biome-ignore format: <tbd>
          console.info('Errore durante la rimozione dell\'aria-label dal pulsante di chiusura del Drawer', e);
        }
      }}
      aria-labelledby={titleId}
      closeIcon={<CloseOutlined ref={closeIconRef} aria-hidden />}
      title={<div id={titleId}>{title}</div>}
      {...otherProps}
    />
  );
}
